import React from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import Icon from '../../../components/AppIcon';

const COLORS = ['#ef4444', '#f97316', '#f59e0b', '#8b5cf6', '#6b7280'];

const RejectionAnalysisPanel = ({ data, loading, totalRejected }) => {
  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
      </div>
    );
  }

  const hasData = data?.length > 0 && totalRejected > 0;

  return (
    <div className="bg-card border border-border rounded-xl p-5">
      <div className="mb-4">
        <h3 className="font-semibold text-foreground">Rejection Analysis</h3>
        <p className="text-xs text-muted-foreground mt-0.5">
          {totalRejected} total rejection{totalRejected !== 1 ? 's' : ''} in selected period
        </p>
      </div>
      {!hasData ? (
        <div className="flex flex-col items-center justify-center py-10 text-muted-foreground">
          <Icon name="CheckCircle" size={36} className="mb-2 opacity-30" />
          <p className="text-sm">No rejections in this period</p>
        </div>
      ) : (
        <div className="flex flex-col lg:flex-row gap-4 items-center">
          <div className="w-full lg:w-1/2">
            <ResponsiveContainer width="100%" height={180}>
              <PieChart>
                <Pie
                  data={data}
                  cx="50%"
                  cy="50%"
                  innerRadius={50}
                  outerRadius={80}
                  paddingAngle={3}
                  dataKey="count"
                >
                  {data?.map((_, i) => (
                    <Cell key={i} fill={COLORS?.[i % COLORS?.length]} />
                  ))}
                </Pie>
                <Tooltip
                  contentStyle={{ background: 'var(--color-card)', border: '1px solid var(--color-border)', borderRadius: 8, fontSize: 12 }}
                />
                <Legend wrapperStyle={{ fontSize: 11 }} />
              </PieChart>
            </ResponsiveContainer>
          </div>
          <div className="w-full lg:w-1/2 space-y-2">
            {data?.map((item, i) => (
              <div key={item?.name} className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <div className="w-3 h-3 rounded-full flex-shrink-0" style={{ background: COLORS?.[i % COLORS?.length] }} />
                  <span className="text-sm text-foreground">{item?.name}</span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-sm font-semibold text-foreground">{item?.count}</span>
                  <span className="text-xs text-muted-foreground">
                    ({totalRejected > 0 ? Math.round((item?.count / totalRejected) * 100) : 0}%)
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default RejectionAnalysisPanel;
